<template>
  <div class="menu-mobile">
    <span class="menu-mobile__toggle" @click="isOpenFirstLevel = true">
      <svg><use xlink:href="#svg-burger"></use></svg>
    </span>
    <Transition name="slide-left">
      <MenuMobileMain
        v-if="isOpenFirstLevel"
        @close="isOpenFirstLevel = false"
        @openMenu="isOpenMenu = true"
        @openCollection="openCollection"
      />
    </Transition>
    <Transition name="slide-left">
      <MenuMobilePrimary
        v-if="isOpenMenu"
        @openSecondLevel="openSecondLevel"
        @close="close"
        @stepBack="isOpenMenu = false"
      />
    </Transition>
    <Transition name="slide-left">
      <MenuMobileSecondary
        v-if="secondLevel"
        :result="secondLevel"
        @stepBack="secondLevel = null"
        @close="close"
      />
    </Transition>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import MenuMobileMain from '@components/Menu/MenuMobile/MenuMobileMain.vue';
import MenuMobilePrimary from '@components/Menu/MenuMobile/MenuMobilePrimary.vue';
import MenuMobileSecondary from '@components/Menu/MenuMobile/MenuMobileSecondary.vue';

export default {
  name: 'MenuMobile',
  components: {
    MenuMobileSecondary,
    MenuMobilePrimary,
    MenuMobileMain,
  },
  data() {
    return {
      isOpenFirstLevel: false,
      secondLevel: null,
      isOpenMenu: false,
    };
  },
  computed: {
    ...mapState({
      mainMenu: ({ results }) => results?.menus?.mainMenu,
    }),
  },
  methods: {
    close() {
      this.isOpenMenu = false;
      this.isOpenFirstLevel = false;
      this.secondLevel = null;
    },
    openSecondLevel(item) {
      this.secondLevel = item;
    },
    openCollection() {
      this.secondLevel = this.mainMenu.items.find((el) => el.isCollection);
    },
  },
};
</script>

<style lang="scss" scoped>
.menu-mobile {
  &__toggle {
    display: block;
    cursor: pointer;
    svg {
      width: 24px;
      height: 24px;
    }
  }
}
.slide-left-enter-active,
.slide-left-leave-active {
  transition: all 0.5s;
}
.slide-left-enter-from,
.slide-left-leave-to {
  transform: translateX(-100%);
}
</style>
